import { Hero } from './hero';

export class HomePageAnimation extends Hero {
  constructor(name, breakpoint) {
    super(name, breakpoint);
  }

  animation() {
    const heroTimeline = gsap.timeline({ paused: true });
    const title = document.querySelector(`${this.name} h1`);
    const button = document.querySelector(`${this.name} .btn-green--primary`);
    const secondaryButton = document.querySelector(`${this.name} .btn-gold`);
    const radioButtons = document.querySelector(`${this.name} #edit-switch`);
    const form = document.querySelector(`${this.name} .search__input-wrapper`);
    const doctorButton = document.querySelector(`${this.name} .find-a-doctor`);
    const locationButton = document.querySelector(
      `${this.name} .find-a-location`
    );

    var kidsWrap = document.querySelector('.kids');

    if (kidsWrap) {
      gsap.registerPlugin(MotionPathPlugin);
      var content = document.querySelector(
        '.homepage-hero--content .container'
      );
      var motionPath = 'M.05,2.17c146.71-14.48,297.11,71.6,431.27,9.57';
      var butterfly = document.createElement('img');
      butterfly.classList.add('butterfly');
      butterfly.setAttribute(
        'src',
        'themes/rush_theme/public/images/butterfly.svg'
      );
      butterfly.setAttribute('role', 'presentation');
      var butterflyPath = document.createElement('div');
      butterflyPath.classList.add('butterfly-path');
      var butterflyPathSVG = document.createElement('img');
      butterflyPathSVG.setAttribute(
        'src',
        'themes/rush_theme/public/images/butterfly-path.svg'
      );
      butterflyPathSVG.setAttribute('role', 'presentation');
      butterflyPath.appendChild(butterflyPathSVG);
      var butterflyMobile = document.createElement('img');
      butterflyMobile.classList.add('butterfly-mobile');
      butterflyMobile.setAttribute(
        'src',
        'themes/rush_theme/public/images/butterfly-mobile.svg'
      );
      butterflyMobile.setAttribute('role', 'presentation');
      content.insertBefore(butterfly, content.childNodes[0]);
      content.insertBefore(butterflyPath, content.childNodes[0]);
      content.insertBefore(butterflyMobile, content.childNodes[0]);

      heroTimeline
        .to(
          butterfly,
          {
            duration: 2,
            ease: 'power1.out',
            yPercent: -20,
            motionPath: motionPath,
          },
          0.5
        )
        .from(butterfly, { duration: 2, ease: 'power4.out', opacity: 0 }, 0.5)
        .from(
          butterflyPath,
          { duration: 2, ease: 'power1.out', width: 0 },
          0.625
        )
        .from(
          butterflyMobile,
          { duration: 2, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0
        )
        .from(
          title,
          { duration: 2, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0
        )
        .from(
          button,
          { duration: 2, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0.25
        )
        .from(
          secondaryButton,
          { duration: 2, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0.25
        )
        .from(
          radioButtons,
          { duration: 2, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0.5
        )
        .from(
          doctorButton,
          { duration: 2, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0.625
        )
        .from(
          locationButton,
          { duration: 2, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0.75
        )
        .from(
          form,
          { duration: 2, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0.625
        );
    } else {
      heroTimeline
        .from(
          title,
          { duration: 2, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0
        )
        .from(
          button,
          { duration: 2, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0.25
        )
        .from(
          secondaryButton,
          { duration: 2, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0.25
        )
        .from(
          radioButtons,
          { duration: 2, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0.5
        )
        .from(
          doctorButton,
          { duration: 2, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0.625
        )
        .from(
          locationButton,
          { duration: 2, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0.75
        )
        .from(
          form,
          { duration: 2, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0.625
        );
    }

    heroTimeline.progress(1).progress(0);
    heroTimeline.play();
  }

  init() {
    this.animation();

    this.breakpoint.addEventListener('change', super.build());
  }
}

export class HomePageHero extends DrupalBehavior {
  onContent(context) {
    const breakpoint = window.matchMedia('(min-width: 768px)');
    const heroElement = context.querySelector('.homepage-hero');
    if (heroElement && !heroElement.classList.contains('hero-loaded')) {
      heroElement.classList.add('hero-loaded');
      const hero = new HomePageAnimation('.homepage-hero', breakpoint);

      hero.init();

      const formSwitches = context.querySelectorAll('input[name="switch"]');
      const doctorForm = context.querySelector(
        '.rush-hero-find-form .search__input-doctor-wrapper'
      );
      const locationForm = context.querySelector(
        '.rush-hero-find-form .search__input-location-wrapper'
      );

      doctorForm.classList.add('active');

      formSwitches.forEach((radio) => {
        radio.addEventListener('click', function (e) {
          const selectedForm = document.querySelector(
            'input[name="switch"]:checked'
          ).value;

          switch (selectedForm) {
            case '0':
              locationForm.classList.remove('active');
              doctorForm.classList.add('active');
              break;
            case '1':
              doctorForm.classList.remove('active');
              locationForm.classList.add('active');
              break;
            default:
              break;
          }
        });
      });
    }
  }
}

DrupalBehavior.register('rush_theme.components', 'homepage_hero', HomePageHero);
